"use strict";

reports.classy.controller({
    name: "ReportsSubNavbarController",
    inject: ["$scope", "$location", "$state"],
    init: function() {

    },
    getSection: function()
    {
        var current = this.$state.current.name.split(".");
        if (current.length < 3)
        {
            return false;
        }
        else if (current.length === 3)
        {
            return current[2];
        }
    }
});